import { forwardRef, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks } from "../../../config/navLinks";
import { Sidenav, Nav } from "rsuite";

const SideNav = () => {
  const currentPath = useLocation().pathname;
  const selectedPage = useMemo(() => currentPath.split("/")[1], [currentPath]);

  const NavLink = forwardRef<HTMLElement>(
    ({ href, children, ...rest }: any, ref) => (
      <Link ref={ref} to={href} {...rest}>
        {children}
      </Link>
    )
  );

  return (
    <Sidenav.Body className={`mb-3`}>
      <Nav>
        {navLinks.map((item) => (
          <Nav.Item
            as={NavLink}
            eventKey={item.name}
            key={item.name}
            icon={item.icon}
            href={item.link}
            className={selectedPage === item.route ? "selected-item" : ""}
          >
            {item.name}
          </Nav.Item>
        ))}
      </Nav>
    </Sidenav.Body>
  );
};

export default SideNav;
